import { NgModule } from '@angular/core';
import { S127gS127m01Component } from './s127g-s127m01.component';
import { SharedModule } from './../../shared.module';

@NgModule({
    imports: [SharedModule],
    exports: [],
    declarations: [S127gS127m01Component]
})
export class S127gModule { }

